module.exports = __webpack_public_path__ + "img/sankaku_35_blue.c94ecd87.png";